/**
 * Video Hero: scroll parallax on background video and unmute button behaviour.
 * Only runs if .video-hero exists.
 */
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

const PARALLAX_STRENGTH = 15;

export function initVideoHeroParallax() {
	const sections = document.querySelectorAll(".video-hero");
	if (!sections.length) return;

	sections.forEach((section) => {
		const bg = section.querySelector(".video-hero__bg");
		const unmuteBtn = section.querySelector(".video-hero__unmute");
		const video = section.querySelector(".video-hero__video");

		// Parallax on scroll (same as media-hero)
		if (bg) {
			gsap.to(bg, {
				yPercent: PARALLAX_STRENGTH,
				ease: "none",
				scrollTrigger: {
					trigger: section,
					start: "top top",
					end: "bottom top",
					scrub: 0.5,
				},
			});
		}

		// Unmute button: toggle muted and update label/icon
		if (unmuteBtn && video) {
			const iconUnmute = unmuteBtn.querySelector(".video-hero__unmute-icon--unmute");
			const iconMute = unmuteBtn.querySelector(".video-hero__unmute-icon--mute");
			const HIDDEN = "video-hero__unmute-icon--hidden";

			unmuteBtn.addEventListener("click", () => {
				video.muted = !video.muted;
				unmuteBtn.setAttribute("data-muted", String(video.muted));
				unmuteBtn.setAttribute("aria-label", video.muted ? "Unmute video" : "Mute video");
				const textEl = unmuteBtn.querySelector(".video-hero__unmute-text");
				if (textEl) textEl.textContent = video.muted ? "Unmute" : "Mute";
				if (iconUnmute) iconUnmute.classList.toggle(HIDDEN, !video.muted);
				if (iconMute) iconMute.classList.toggle(HIDDEN, video.muted);
			});
		}
	});
}
